export default __webpack_public_path__ + "static/media/avatar-1.1a8b3fc1.jpg";